import { Route } from '@angular/router';

import { AuthLayoutComponent } from './components/auth-layout/auth-layout.component';

export const AUTH_ROUTES: Route[] = [
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: 'login',
        loadComponent: () => import('./components/login/login.component').then((mod) => mod.LoginComponent),
      },
      {
        path: '**',
        redirectTo: '/page-not-found',
      },
    ],
  },
];
